import { EventSegment } from '@fullcalendar/core'
import { ClickAwayListener, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import { t } from 'i18next'
import { ReactElement, ReactNode, useState } from 'react'
import { Root } from 'react-dom/client'
import LocalStorage from 'services/LocalStorage'
import { theme } from 'theme'
import { EventDoc } from 'types/api/changes'
import { LocalStorageKey } from 'types/services/localStorage'
import { eventLengthInDays } from 'utils/event'

import Popup, { PopupInstance } from '../popup/Popup'

export interface EventsListPopupProps {
  children?: ReactElement
  events: EventSegment[]
  root?: Root
  date?: Date
  eventDrawer?: (eventSegment: EventSegment) => ReactNode
  instance?: PopupInstance
  onInstance?: (instance: PopupInstance) => void
  onAway?: () => void
}

export default function EventsListPopup(props: EventsListPopupProps) {
  return (
    <ClickAwayListener
      key={'list-popup-away'}
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={() => {
        if (LocalStorage.get(LocalStorageKey.SHOULD_KEEP_POPUP) === '1') return
        if (props.onAway) props.onAway()
        props.root?.render(
          <Box>{t('moreAmount', { more: props.events.length })}</Box>
        )
        props.instance?.hide()
        LocalStorage.remove(LocalStorageKey.VISIBLE_EVENT)
      }}
    >
      <div>
        <Popup
          onMount={props.onInstance}
          open
          content={<EventsListPopupContent {...props} />}
        >
          {props.children}
        </Popup>
      </div>
    </ClickAwayListener>
  )
}

export function EventsListPopupContent(props: EventsListPopupProps) {
  return (
    <Grid
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      style={{
        overflowY: 'auto',
        backgroundColor: 'white',
        width: '100%',
        height: 'fit-content',
        maxHeight: '300px',
        pointerEvents: 'all'
      }}
    >
      {props.events.map((event) =>
        props.eventDrawer ? (
          <Box
            key={event.event.id}
            sx={{
              marginTop: '4px',
              width: () => {
                return '100%'
              }
            }}
          >
            {props.eventDrawer(event)}
          </Box>
        ) : (
          <Box
            sx={{
              color: 'black',
              width: '100%'
            }}
            key={event.event.extendedProps.eventModel._id}
          >
            {event.event.extendedProps.eventModel.Text}
          </Box>
        )
      )}
    </Grid>
  )
}
